import posthog from 'posthog-js';

import appConfig from '@palette/config/app';

export const posthogClient = posthog.init(
  appConfig.REACT_APP_PUBLIC_POSTHOG_KEY, {
    api_host: appConfig.REACT_APP_PUBLIC_POSTHOG_HOST,
  },
);
